<template>
    <div class="message-scroll px-12 py-12 fci-scrollbar"
         :class="{'no-wave-audio': !hasWaveform,'no-audio-data':!hasAudioData}">
        <!-- Summary Section -->
        <v-layout>
            <div>
                <h2>{{ $f.tc('summary') }}</h2>
                <div>
                    <p v-for="(line, indexLine) in formattedTextSummary(callSummary)" :key="indexLine">{{ line }}</p>
                </div>
            </div>
        </v-layout>

        <!-- Criteria Section -->
        <v-layout v-if="analysisList.length > 0">
            <div>
                <h2>{{ $f.tc('criteria') }}</h2>
                <div v-for="(item, index) in analysisList" :key="index">
                    <v-card>
                        <v-card-title>
                            <h3> {{ item['input']['label'] }}</h3>
                        </v-card-title>
                        <v-card-text>
                            <p v-for="(line, indexLine) in formattedText(item)" :key="indexLine">
                                {{ line }}
                            </p>
                        </v-card-text>
                    </v-card>
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>

export default {
    name: 'ScenarioHistoryOverview',
    data () {
        return {}
    },
    props: {
        analysisList: {
            type: Array,
            default: () => []
        },
        callSummary: {
            type: String,
            default: () => ''
        },
        hasWaveform: {
            type: Boolean,
            default: () => true
        },
        hasAudioData: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        formattedText (item) {
            let output = item?.output
            let text = this.$f.tc('noDataAvailable')
            if (!!output) {
                text = output.text ? output.text : ''
            }
            return text.split('\n')
        },
        formattedTextSummary (text) {
            return text.split('\n')
        }
    },
}
</script>

<style scoped lang="scss">
@import "chat.scss";

.message-scroll {
    height: calc(100vh - 337px);
    overflow: auto;
}

/* Add styles for when wave visualization is not available */
.no-wave-audio {
    height: calc(100vh - 263px);
    overflow: auto;
}

.no-audio-data {
    height: calc(100vh - 223px);
    overflow: auto;
}

.v-card__title {
    padding: 16px 0 0 16px;
}

.call-audio {
    display: flex;
    align-items: center;

    audio {
        width: 100%;
        height: 30px;
    }
}

</style>
